module.exports = __webpack_public_path__ + "img/avp_bck_alt_small@2x.0a704d6.webp";